import type { ExtensionItem } from '@hygge/shared';
import { api } from './api';

export async function getExtensions(): Promise<ExtensionItem[]> {
  const { data } = await api.get<ExtensionItem[]>('/extensions');
  return data;
}

export async function getExtension(id: string): Promise<ExtensionItem> {
  const { data } = await api.get<ExtensionItem>(`/extensions/${id}`);
  return data;
}

export async function enableExtension(id: string): Promise<ExtensionItem> {
  const { data } = await api.post<ExtensionItem>(`/extensions/${id}/enable`);
  return data;
}

export async function disableExtension(id: string): Promise<ExtensionItem> {
  const { data } = await api.post<ExtensionItem>(`/extensions/${id}/disable`);
  return data;
}

export async function updateExtensionSettings(
  id: string,
  settings: Record<string, unknown>,
): Promise<ExtensionItem> {
  const { data } = await api.patch<ExtensionItem>(`/extensions/${id}`, { settings });
  return data;
}
